export function MaterialInput(inputGroup) {
    this.container = inputGroup
    this.input = this.container.querySelector('.material-form__input')
    this.stringCheck = /\S/
    this.init()
}

MaterialInput.prototype = {
    init() {
        this.inputValueChecker()
        this.addingListeners()
    },

    inputValueChecker(e) {
        const group = this.container
        let value = this.input.value
        if (this.stringCheck.test(value)) {
            group.classList.add('material-form--input-populated')
            return
        }
        group.classList.remove('material-form--input-populated')
    },

    toggleFocus(focus) {
        focus ? this.container.classList.add('material-form--focused') : this.container.classList.remove('material-form--focused')
    },

    addingListeners() {
        this.input.addEventListener('keydown', (e) => this.inputValueChecker(e))
        this.input.addEventListener('blur', (e) => this.inputValueChecker(e))
        this.input.addEventListener('focus', (e) => this.toggleFocus(true))
        this.input.addEventListener('blur', (e) => this.toggleFocus(false))
    }

}